module.exports = __webpack_public_path__ + "img/Live互動英語.f2b91517.png";